import { v4 as uuidv4 } from 'uuid';

const STORAGE_KEY = 'sessionId';
const FORM_VALUE_KEY = 'formValues';
// Which question set (flow directory) and product collected the stored form
// values. Read by the question engine to decide whether they can be reused,
// and by dataLayer.js to derive step numbers for a flow variant.
const FORM_VALUE_META_KEY = 'formValuesMeta';
const VDN_KEY = 'vdn';
const DEFAULT_VDN = '16779';

const SessionManager = {
  getSessionId: function () {
    let sessionId =
      localStorage.getItem(STORAGE_KEY) || sessionStorage.getItem(STORAGE_KEY);

    if (!sessionId) {
      sessionId = uuidv4();
      localStorage.setItem(STORAGE_KEY, sessionId);
    }

    return sessionId;
  },

  setSessionId: function (sessionId, useSessionStorage = false) {
    if (useSessionStorage) {
      sessionStorage.setItem(STORAGE_KEY, sessionId);
    } else {
      localStorage.setItem(STORAGE_KEY, sessionId);
    }
  },

  clearSessionId: function () {
    localStorage.removeItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
  },

  getFormValues: function () {
    const raw = localStorage.getItem(FORM_VALUE_KEY);
    try {
      return raw ? JSON.parse(raw) : null;
    } catch (err) {
      return null;
    }
  },

  setFormValues: function (
    formValue,
    protectedFields = ['IDNumber'], // These are fields you dont want to overwrite
    meta = null // { product, questionSet } of the flow that collected them
  ) {
    try {
      const existingRaw = localStorage.getItem(FORM_VALUE_KEY);
      const existing = existingRaw ? JSON.parse(existingRaw) : {};

      const merged = { ...formValue };

      for (const key of protectedFields) {
        if (existing[key] !== undefined) {
          merged[key] = existing[key];
        }
      }

      const json = JSON.stringify(merged);
      localStorage.setItem(FORM_VALUE_KEY, json);

      if (meta && meta.product && meta.questionSet) {
        localStorage.setItem(
          FORM_VALUE_META_KEY,
          JSON.stringify({
            product: meta.product,
            questionSet: meta.questionSet,
          })
        );
      }
    } catch (err) {
      // ignore
    }
  },

  getFormValuesMeta: function () {
    try {
      const raw = localStorage.getItem(FORM_VALUE_META_KEY);
      const parsed = raw ? JSON.parse(raw) : null;
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (err) {
      return null;
    }
  },

  // Captures a `vdn` query param into session storage, if present in
  // the given search string (e.g. window.location.search).
  captureVdnFromQueryString: function (search) {
    const vdn = new URLSearchParams(search).get(VDN_KEY);
    if (vdn) {
      sessionStorage.setItem(VDN_KEY, vdn);
    }
  },

  getVdn: function () {
    return sessionStorage.getItem(VDN_KEY) || DEFAULT_VDN;
  },
};

export default SessionManager;
